import React from "react";
import { ArrowRight, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HersBinsServices() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll();
  return <section data-section-id="39517" id="the-future-of-cannabis-operations" className="dark relative h-screen w-full overflow-hidden bg-[#1A5A8E] text-white">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/pristine_commercial_facility.png)] bg-cover bg-center opacity-40 mix-blend-overlay" />

      {}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1A5A8E] via-[#1A5A8E]/90 to-[#4092C7]" />

      {}
      <div className="relative z-10 flex h-full max-w-7xl flex-col justify-center px-8 mx-auto">
        <div ref={contentRef} className={`flex flex-col transition-all duration-1000 ease-out ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <h1 className="font-sans text-5xl font-bold leading-tight text-white md:text-[80px] tracking-tighter">
            The Future of{" "}
            <span className="text-[#59A6D9] drop-shadow-[0_0_20px_rgba(89,166,217,0.5)]">
              Cannabis Operations
            </span>
          </h1>

          {}
          <p className="mt-6 max-w-[650px] font-sans text-lg leading-relaxed text-[#F8FAFC] md:text-[24px]">
            Cannabis Cloud unifies retail point of sale, CRM, compliance workflows, 
            and AI-powered operations into one connected Salesforce platform designed 
            for vertical growth and confidence.
          </p>

          {}
          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Button asChild className="h-[64px] w-full rounded-3xl bg-gradient-to-r from-[#1A5A8E] to-[#2A71A7] text-lg font-bold text-white shadow-2xl transition-all hover:scale-105 hover:shadow-[#1A5A8E]/40 sm:w-[240px]">
              <Link to="/HomePage">
                <Search className="mr-2 h-5 w-5" />
                Get Started
              </Link>
            </Button>

            <Button asChild variant="outline" className="h-[64px] w-full rounded-3xl border-white/20 bg-white/5 backdrop-blur-md text-lg font-semibold text-white transition-all hover:bg-white/15 hover:border-white/40 sm:w-[240px]">
              <Link to="#">
                Watch Video
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 flex -translate-x-1/2 flex-col items-center gap-2">
        <span className="text-xs font-mono uppercase tracking-[0.2em] text-[#F8FAFC]/60">
          Scroll
        </span>
        <div className="h-16 w-[1px] overflow-hidden bg-white/10">
          <div className="h-1/2 w-full animate-bounce bg-[#59A6D9]" />
        </div>
      </div>
    </section>;
}